const note = {
    version: '1.1.0',
    date: '2026-08-29',
    tags: ['Nyt'],
    body: `
- **Reminders.** Ny fane, hvor du vælger, hvilke ugedage den enkelte employee får en mail om manglende timelogs.
`,
};

export default note;
